/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const Vue = require('vue');

require('./aside-layout.scss');
require('src/common/lib/jquery.scrollbar-gh-pages/jquery.scrollbar.css')
require('src/common/lib/jquery.scrollbar-gh-pages/jquery.scrollbar.min.js');

const template = require('./aside-layout.tpl');
const tip = require('components/base/pop/tip');
const store = require('appVuex/store');
const { apiPath } = require('appService/api');
const { setLoginInfo } = require('appVuex/action/login');
require('components/base/pop/pop');

var AsideLayout = Vue.extend({
  props:{
    menus: {
      require: true,
      type: Array
    }
  },

	data() {
		return {
      "toggleFlag": false,
      "menuData": {},
      "active": {
        pIndex: 0
      }
		}
  },

	ready() {
    $(window).on('resize', ()=>{
      this.resizeNav();
    });
    window.AB.componentHub.menus = this;
  },

  template,

  methods: {
    toggleAside(){
      let $dom = $(".tab-content");
      this.toggleFlag = !this.toggleFlag;
      this.$dispatch('toggle', this.toggleFlag);

      this.toggleFlag == false ? $dom.css("padding-right", "10px") : $dom.css("padding-right", "4px");
    },
    resizeNav() {
      let $navScroller = $('#nav-scroll');
      let navH = $navScroller.height();
      let bodyH = $(window).height() - 80;

      if (navH >= bodyH) {
        $navScroller.scrollbar();
      } else {
        $navScroller.css('max-height','auto');
      }

      $('.scroll-wrapper').css('height', bodyH);
    },

    returnBackImg(url) {
      return `background-image: url(${url})`;
    },

    forbid(status) {
      if (status == 1) {
        return true;
      } else {
        tip('暂无权限访问该页面, 请联系管理员！');
      }
    },

    saveIndex(index, type, url) {
      if (type === 0) {
        this.active.pIndex = index;
        this.$router.go({
          path: url
        });
      }
    }
  },

  events: {
    "initScroll": function() {
      this.resizeNav();
    }
  }
});

module.exports = AsideLayout;




// WEBPACK FOOTER //
// ./src/appBackend/components/layout/aside-layout/aside-layout.js